/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="payroll.module.ts" />


import SecurityParts = Meevo.Components.Common.SecurityParts;
import SecurityKeys = Meevo.Components.Common.SecurityKeys;

module Meevo.Plugins.Payroll {

    export interface IPayrollPeriod {
        currentAsOfDate?: string;
        errorHeaderCount?: string;
        locationId?: string;
        objectCreationType?: string;
        payrollEndDate?: string;
        payrollPeriodId?: Guid;
        payrollPeriodStatusEnum?: string;
        payrollStartDate?: string;
        payrollTypeEnum?: string;
        processingHeaderCount?: string;
        retailHeaderCount?: string;
        serviceHeaderCount?: string;
        serviceRetailHeaderCount?: string;
        terminatedCount?: string;
        payrollPeriod_ADPPeriod_LId?: Guid;
        payrollFrequencyEnum?: string;
    }


    class PayrollController {
        static $inject = ["meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            'meevo.components.common.PayRollService',
            "$rootScope",
            "$scope",
            "$state",
            "$filter",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "$translate",
            "$timeout",
            "meevo.components.common.BusinessInfoDataService",
            '$mdToast',
            'meevoDateFilterFilter'];

        protected showSearch: boolean;

        protected endpoint: string;
        protected items: any;
        protected startDate: any;
        protected endDate: any;
        protected hasConflicts: boolean;
        protected currentPayroll: boolean;
        protected openPayroll: boolean;
        protected archivedPayroll: boolean;
        protected employeeDetail: Model.DataDetail;
        protected servicePayroll: boolean;
        protected retailPayroll: boolean;
        protected isErrorPayroll: boolean;
        protected terminatedDate: any;
        private currentEmployee: any;
        private adpIntegration: Model.ADPIntegrationSettings; //AdpRun = 11045093,  AdpWfn = 11045094

        protected payrollItem: any;
        protected employeePayrolls: any;
        protected employeeFilter: any;
        protected employeeCatFilter: any;
        public showAdvancedMobile: boolean;
        public reprocessAll: boolean;
        public numItemsProcessing: number;
        public showTerminatedEmployeeToolTip: boolean;

        
        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;
        protected _identityService: Meevo.Components.Common.IIdentityService
        toast;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected payrollService: Meevo.Components.Common.PayRollService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected $filter: ng.IFilterService,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService,
            protected businessInfoDataService: Meevo.Components.Common.IBusinessInfoDataService,
            public $mdToast: angular.material.IToastService,
            protected meevoDateFilter: any,
            protected Service: Meevo.Components.Common.IBusinessInfoDataService) {

            this.endpoint = 'payroll';
            this.showSearch = true;
            this.items = new Meevo.Components.BaseClasses.PagedResults(this.dataService, this.endpoint, this.onPageRetrievedCallback);
            this.showAdvancedMobile = false;
            this.reprocessAll = false;
            this.numItemsProcessing = 0;
            this.showTerminatedEmployeeToolTip = false;
            this.currentPayroll = true;
            this.openPayroll = true;
            this.archivedPayroll = true;
            this.servicePayroll = true;
            this.retailPayroll = true;
            var nowdate1 = new Date();
            this.startDate = moment(new Date(nowdate1.getFullYear(), nowdate1.getMonth(), 1));
            this.endDate = moment(new Date(nowdate1.getFullYear(), nowdate1.getMonth() + 1, 0));
            this.getStartEndDate();
            this._identityService = identityService;
            businessInfoDataService.getBusinessInfoPreferences()
                .then(settings => {
                    const data: Meevo.Plugins.BusinessInfo.IBusinessInfoClientsSettings = settings.clientsSettings;
                });

            //AdpRun = 11045093,  AdpWfn = 11045094
            let that = this;
            this.dataService.customMethodData('api/' + 'settings/AdpIntegration', 'get', null).then(function (result) {
                that.adpIntegration = result.data;

                //settings does not have adpIntegrationType. Set it based on which status is enabled
                //payroll integrations are run or wfn
                if (that.adpIntegration.adpWFNIntegrationStatus)
                    that.adpIntegration['adpIntegrationType'] = 11045094; //wfn
                else // default if (that.adpIntegration.adpIntegrationStatus)
                    that.adpIntegration['adpIntegrationType'] = 11045093; //run

            });
        }


        private onPageRetrievedCallback = (pageNumber: number, page: any[], context: any): void => {
            //if (page && page.length > 0) {
            //    this.adpIntegration.adpIntegrationStatus = !!page[0].isAdpEnabled;
            //    if (this.isAdpIntegrationEnabled)
            //        this.adpIntegrationType = page[0].adpIntegrationType;
            //} else {
            //    this.isAdpIntegrationEnabled = false;
            //}
        };

        closeContext = (): void => {
            this.$rootScope.$broadcast("closeContext", this.$state.current, null);
        };

        getStartEndDate = (): void => {
            var that = this;
            if (Model.Guard.isNothing(that.startDate)) that.startDate = moment().toDate();
            if (Model.Guard.isNothing(that.endDate)) that.endDate = moment().toDate();

            var startDate = new Date(that.startDate.toString()), ys = startDate.getFullYear(), ms = startDate.getMonth();
            var endDate = new Date(that.endDate.toString()), ye = endDate.getFullYear(), me = endDate.getMonth();
            var firstDay = new Date(ys, ms, 1);
            var lastDay = new Date(ye, me + 1, 0);
            that.startDate = moment(firstDay).toDate();
            that.endDate = moment(lastDay).toDate();
        }
        clearAdvancedSearch = () => {
            this.hasConflicts = false;
            this.hasConflicts = false;
            this.currentPayroll = true;
            this.openPayroll = true;
            this.archivedPayroll = true;
            this.employeeDetail = null;
            this.servicePayroll = true;
            this.retailPayroll = true;
            this.isErrorPayroll = false;
            this.modalService.hide();
            this.initializeSearch();
        }

        toggleShowAdvanced = (): void => {
            // this.getStartEndDate();
            this.startDate = new Date(this.startDate);
            this.endDate = new Date(this.endDate);
            this.startDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), 1);
            this.endDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth() + 1, 0);
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/payroll/views/advancedSearch.html',
                controller: 'meevo.plugins.payroll.PayrollController',
                controllerAs: "vm",
                bindToController: true,
                escapeToClose: false,
                clickOutsideToClose: false,
                locals: { payrollController: this }
            }
            this.modalService.showCustom(options);
        }

        toggleShowAdvancedMobile = (): void => {
            this.showAdvancedMobile = !this.showAdvancedMobile;
        }


        showToast = (id, date) => {
            let toast = this.$mdToast.simple();
            toast.theme("error-toast");
            toast.textContent(this.$translate.instant("LABEL_TERMINATE_DATE") + ': ' + this.meevoDateFilter(date));
            toast.position("right");
            toast.parent(angular.element(".payroll-pay-container")[id]);
            toast.hideDelay(1500);

            this.$mdToast.show(toast);

           
        }

        sorterFunc = (item: any) => {
            return parseInt(item.employeeNumber);
        }

        initializeSearch = () => {
            let request = {
                pageNumber: 1,
                itemsPerPage: 25,
                criteria: {
                    startDate: Model.Guard.isSomething(this.startDate) ? moment(this.startDate).toDate() : null,
                    endDate: Model.Guard.isSomething(this.endDate) ? moment(this.endDate).toDate() : null,
                    hasConflicts: false,
                    currentPayroll: true,
                    openPayroll: true,
                    archivedPayroll: true,
                    employeeDetail: this.employeeDetail,
                    servicePayroll: true,
                    retailPayroll: true,
                    isErrorPayroll: false
                }
            };
            request.criteria.hasConflicts = this.hasConflicts;
            request.criteria.currentPayroll = this.currentPayroll;
            request.criteria.openPayroll = this.openPayroll;
            request.criteria.archivedPayroll = this.archivedPayroll;
            request.criteria.servicePayroll = this.servicePayroll;
            request.criteria.retailPayroll = this.retailPayroll;
            request.criteria.isErrorPayroll = this.isErrorPayroll;

            if (this.startDate > this.endDate || (!this.retailPayroll && !this.servicePayroll)) {

                this.modalService.alert("MESSAGE_COMPLETE_ALL_FIELDS_THAT_REQUIRE_ATTENTION", 0, true);

            } else {
                let trackingItem = new Model.TrackingItem(Model.NounEnum.PayrollPage, Model.VerbEnum.SearchButtonClicked, request.criteria, null);
                this.trackingService.saveTrackingInfo(trackingItem);
                this.items.initSearch(request);
                
                this.modalService.hide();
                var nowdate2 = new Date();
                if (Model.Guard.isNothing(this.startDate) || Model.Guard.isNothing(this.endDate)) {
                    this.startDate = moment(new Date(nowdate2.getFullYear(), nowdate2.getMonth(), 1));
                    this.endDate = moment(new Date(nowdate2.getFullYear(), nowdate2.getMonth() + 1, 0));
                }
            }

        };

        getPayrollItem = (item: any, employee?: boolean) => {
            if (!employee)
                this.busyService.start();

            let that = this;
            this.payrollItem = item;

            let payload = {
                PayrollId: item.payrollPeriodId,
                Status: Model.PayrollPeriodStatusEnum[item.payrollPeriodStatusEnum],
                Date: `From ${moment(item.payrollStartDate).format('L')} To ${moment(item.payrollEndDate).format('L')}`,
            }

            let trackingItem = new Model.TrackingItem(Model.NounEnum.PayrollPage, Model.VerbEnum.PayrollPeriodViewed, payload, null);
            this.trackingService.saveTrackingInfo(trackingItem);
            this.dataService.getItem(this.endpoint, item.payrollPeriodId).then(function (result) {

                let ratio: number = 0;
                that.numItemsProcessing = 0;
                
                that.employeePayrolls = result;
                that.showSearch = false;

                for (let item of that.employeePayrolls) {
                    if (item.isProcessing)
                        that.numItemsProcessing++;
                }

                if (that.numItemsProcessing > 0)
                    ratio = that.numItemsProcessing / that.employeePayrolls.length;

                that.reprocessAll = ratio == 1 ? true : false;

                if (!employee)
                    that.busyService.stop();
            });
        }

        employeeCategoryChanged = () => {
            this.busyService.start();
            var request: any = {};
            request.payrollId = this.payrollItem.payrollPeriodId;
            request.employeeCatId = this.employeeCatFilter ? this.employeeCatFilter.id : null;
            let that = this;
            this.dataService.customMethodData('api/' + this.endpoint + '/' + this.payrollItem.payrollPeriodId, 'post', request).then(function (result) {
                that.employeePayrolls = result.data;
                that.busyService.stop();
            });
        }

        getPayDetail = (employeePayrollItem) => {

            if (employeePayrollItem.details) {
                employeePayrollItem.open = !employeePayrollItem.open;
                return;
            }

            let payload = _.omit(employeePayrollItem, ['details', '$$hashKey', 'open']);
            let trackingItem = new Model.TrackingItem(Model.NounEnum.PayrollPage, Model.VerbEnum.PayrollDetailsViewed, employeePayrollItem, null);
            this.trackingService.saveTrackingInfo(trackingItem);
            this.currentEmployee = employeePayrollItem
            
            this.busyService.start();
            var request = {
                employeePayId: employeePayrollItem.employeePayId
            };
            let that = this;

            this.dataService.customMethodData('api/' + this.endpoint + '/EmployeeDetail', 'post', request).then(function (result) {
                employeePayrollItem.details = result.data;
                var empTotalweeks = _.groupBy(employeePayrollItem.details.hoursDetails, "weekId");
                var employeeTotalweeks = [];
                var totalWageAmount = 0;
                var countRegularHour: number = 0;
                var employeeTotalHours: any = {
                    dailyExtOvertimeHours: 0, dailyExtOvertimeRate: 0, dailyExtOvertimeWages: 0, eightHourPlusOvertTimeHours: 0, eightHourPlusOvertimeRate: 0, eightHourPlusOvertimeWages: 0,
                    holidayHours: 0, holidayRate: 0, holidayWages: 0, otTypeEnum: 0, overTimeHours: 0, overTimeRate: 0, overTimeWages: 0, regularHours: 0, regularRate: 0, regularWages: 0, sevenDayExtOvertimeHours: 0,
                    sevenDayExtOvertimeRate: 0, sevenDayExtOvertimeWages: 0, sevenDayOvertimeHours: 0, sevenDayOvertimeRate: 0, sevenDayOvertimeWages: 0, sickHours: 0, sickRate: 0, sickWages: 0, totalAmount: 0,
                    weekEndDate: "", weekStartDate: "", showTotalHoursDetails: 0, vacationPtoHours: 0, vacationPtoRate: 0, vacationPtoWages: 0
                };
                
                if (employeePayrollItem.isPaymentHeaderAtHomeLocation)
                {    _.forEach(empTotalweeks, (item: any) => {
                        employeeTotalHours = {
                            dailyExtOvertimeHours: 0, dailyExtOvertimeRate: 0, dailyExtOvertimeWages: 0, eightHourPlusOvertTimeHours: 0, eightHourPlusOvertimeRate: 0, eightHourPlusOvertimeWages: 0,
                            holidayHours: 0, holidayRate: 0, holidayWages: 0, otTypeEnum: 0, overTimeHours: 0, overTimeRate: 0, overTimeWages: 0, regularHours: 0, regularRate: 0, regularWages: 0, sevenDayExtOvertimeHours: 0,
                            sevenDayExtOvertimeRate: 0, sevenDayExtOvertimeWages: 0, sevenDayOvertimeHours: 0, sevenDayOvertimeRate: 0, sevenDayOvertimeWages: 0, sickHours: 0, sickRate: 0, sickWages: 0, totalAmount: 0,
                            weekEndDate: "", weekStartDate: "", showTotalHoursDetails: 0, vacationPtoHours: 0, vacationPtoRate: 0, vacationPtoWages: 0
                    };

                        _.forEach(item, (week: any) => {

                            employeeTotalHours.dailyExtOvertimeHours = employeeTotalHours.dailyExtOvertimeHours + week.dailyExtOvertimeHours;
                            employeeTotalHours.dailyExtOvertimeRate = employeeTotalHours.dailyExtOvertimeRate + week.dailyExtOvertimeRate;
                            employeeTotalHours.dailyExtOvertimeWages = employeeTotalHours.dailyExtOvertimeWages + week.dailyExtOvertimeWages;
                            totalWageAmount += week.dailyExtOvertimeWages;
                            employeeTotalHours.eightHourPlusOvertTimeHours = employeeTotalHours.eightHourPlusOvertTimeHours + week.eightHourPlusOvertTimeHours;
                            employeeTotalHours.eightHourPlusOvertimeRate = employeeTotalHours.eightHourPlusOvertimeRate + week.eightHourPlusOvertimeRate;
                            employeeTotalHours.eightHourPlusOvertimeWages = employeeTotalHours.eightHourPlusOvertimeWages + week.eightHourPlusOvertimeWages;
                            totalWageAmount += week.eightHourPlusOvertimeWages;
                            employeeTotalHours.holidayHours = employeeTotalHours.holidayHours + week.holidayHours;
                            employeeTotalHours.holidayRate = employeeTotalHours.holidayRate + week.holidayRate;
                            employeeTotalHours.holidayWages = employeeTotalHours.holidayWages + week.holidayWages;
                            totalWageAmount += week.holidayWages;
                            if (week.otTypeEnum = 1948) {
                                employeeTotalHours.otTypeEnum = 1948
                                employeeTotalHours.overTimeHours = employeeTotalHours.overTimeHours + week.overTimeHours;
                                employeeTotalHours.overTimeRate = employeeTotalHours.overTimeRate + week.overTimeRate;
                                employeeTotalHours.overTimeWages = employeeTotalHours.overTimeWages + week.overTimeWages;
                                totalWageAmount += week.overTimeWages;
                                employeeTotalHours.regularHours = employeeTotalHours.regularHours + week.regularHours;
                                employeeTotalHours.regularRate = employeeTotalHours.regularRate + week.regularRate;
                                employeeTotalHours.regularWages = employeeTotalHours.regularWages + week.regularWages;
                                totalWageAmount += week.regularWages;
                                employeeTotalHours.sevenDayExtOvertimeHours = employeeTotalHours.sevenDayExtOvertimeHours + week.sevenDayExtOvertimeHours;
                                employeeTotalHours.sevenDayExtOvertimeRate = employeeTotalHours.sevenDayExtOvertimeRate + week.sevenDayExtOvertimeRate;
                                employeeTotalHours.sevenDayExtOvertimeWages = employeeTotalHours.sevenDayExtOvertimeWages + week.sevenDayExtOvertimeWages;
                                totalWageAmount += week.sevenDayExtOvertimeWages;
                                employeeTotalHours.sevenDayOvertimeHours = employeeTotalHours.sevenDayOvertimeHours + week.sevenDayOvertimeHours;
                                employeeTotalHours.sevenDayOvertimeRate = employeeTotalHours.sevenDayOvertimeRate + week.sevenDayOvertimeRate;
                                employeeTotalHours.sevenDayOvertimeWages = employeeTotalHours.sevenDayOvertimeWages + week.sevenDayOvertimeWages;
                                totalWageAmount += week.sevenDayOvertimeWages;
                            }
                            employeeTotalHours.sickHours = employeeTotalHours.sickHours + week.sickHours;
                            employeeTotalHours.sickRate = employeeTotalHours.sickRate + week.sickRate;
                            employeeTotalHours.sickWages = employeeTotalHours.sickWages + week.sickWages;
                            totalWageAmount += week.sickWages;
                            employeeTotalHours.vacationPtoHours = employeeTotalHours.vacationPtoHours + week.vacationPtoHours;
                            employeeTotalHours.vacationPtoRate = employeeTotalHours.vacationPtoRate + week.vacationPtoRate;
                            employeeTotalHours.vacationPtoWages = employeeTotalHours.vacationPtoWages + week.vacationPtoWages;
                            totalWageAmount += week.vacationPtoWages;
                            employeeTotalHours.totalAmount = employeeTotalHours.totalAmount + week.totalAmount;
                            employeeTotalHours.weekEndDate = week.weekEndDate;
                            employeeTotalHours.weekStartDate = week.weekStartDate;
                            if (employeeTotalHours.regularHours > 0) {
                                countRegularHour++;
                            }

                        });
                        employeeTotalweeks.push(employeeTotalHours)
                    });
                    employeePayrollItem.details.employeeTotalWages = totalWageAmount;
                    employeePayrollItem.details.hoursTotal = employeeTotalweeks;
                    employeePayrollItem.details.employeeSalary = employeePayrollItem.details.employeeSalary;
                    employeePayrollItem.details.showTotalHoursDetails = countRegularHour > 0 ? true : false ;
                }

                if (!employeePayrollItem.isMultiLocation) 
                {
                    employeePayrollItem.details.locationId = that.identityService.locationId;
                if (Model.Guard.isNothing(employeePayrollItem.details.locationPayDetails))
                    employeePayrollItem.details.locationPayDetails = [];
                  
                    employeePayrollItem.details.locationPayDetails.push(employeePayrollItem.details);
                }

                employeePayrollItem.details.locationPayDetails = _.uniq(employeePayrollItem.details.locationPayDetails, (x: any) => {
                        return x.locationId;
                    });
                    var locationsHours = angular.copy(employeePayrollItem.details.locationPayDetails );
                _.forEach(employeePayrollItem.details.locationPayDetails, (location: any) => {
                    var showHoursWeekCount = 0;
                        location.showHoursDetails = false;
                        location.showDetails = employeePayrollItem.isPaymentHeaderAtHomeLocation ? true : that.identityService.locationId == location.locationId;
                        location.pinned = that.identityService.locationId == location.locationId ? 1 : 2;
                        location.employeeSalary = employeePayrollItem.details.employeeSalary;
                        location.hoursDetails = _.where(employeePayrollItem.details.hoursDetails, { locationId: location.locationId });
                        location.hours = _.findWhere(locationsHours, { locationId: location.locationId });
                        location.membershipDetails = _.findWhere(employeePayrollItem.details.membershipDetails, { locationId: location.locationId });
                        location.packageDetails = _.findWhere(employeePayrollItem.details.packageDetails, { locationId: location.locationId });
                        location.retailDetails = _.findWhere(employeePayrollItem.details.retailDetails, { locationId: location.locationId });
                        location.serviceDetails = _.findWhere(employeePayrollItem.details.serviceDetails, { locationId: location.locationId });
                        location.serviceToRetail = _.findWhere(employeePayrollItem.details.serviceToRetail, { locationId: location.locationId });
                        location.tipDetails = _.findWhere(employeePayrollItem.details.tipDetails, { locationId: location.locationId });

                        location.totalWages = 0;

                    _.forEach(location.hoursDetails, (week: any) => {
                        if (week.regularHours > 0 || week.holidayHours > 0 || week.sickHours > 0 || week.vacationPtoHours > 0)
                            {
                                    showHoursWeekCount++;
                            }
                            location.showHoursDetails = showHoursWeekCount > 0 ? true : false ;
                            location.totalWages = (location.totalWages + week.dailyExtOvertimeWages + week.eightHourPlusOvertimeWages + week.overTimeWages + week.regularWages + week.sevenDayOvertimeWages + week.sevenDayExtOvertimeWages + week.holidayWages + week.sickWages + week.vacationPtoWages);
                        });
                    });

                    employeePayrollItem.open = true;
                    employeePayrollItem.details.locationPayDetails = _.sortBy(employeePayrollItem.details.locationPayDetails, 'locationDisplayName');
                    employeePayrollItem.details.locationPayDetails = _.sortBy(employeePayrollItem.details.locationPayDetails, 'pinned');
                    that.busyService.stop();
                });
        
        }

        recalculate = (isMLPayrollEnable?: boolean,employee?: any) => {

            var request;
            if (Model.Guard.isSomething(employee)) {

                if (!employee.isProcessing) {
                    employee.isProcessing = true;
                    this.numItemsProcessing++;
                }                    

                request = {
                    payrollEmployeeId: employee.employeePayId,
                    isMLPayrollEnable: isMLPayrollEnable
                }
            } else {
                this.reprocessAll = true;
                this.numItemsProcessing = this.payrollItem.length;
                request = {
                    payrollPeriodId: this.payrollItem.payrollPeriodId,
                    isMLPayrollEnable: isMLPayrollEnable
                }
            }

            let that = this;
            this.dataService.customMethodData('api/' + this.endpoint + '/recalculate', 'post', request).then(function (result) {
                if (Model.Guard.isNothing(employee)) {
                   that.getPayrollItem(that.payrollItem);
               }
            });
        }

        public submitToAdp(employeePayId: string = null): void {
            const hasMappedEmployees = !!this.employeePayrolls.find(ep => ep.isEmpAdpMapped === true);
            if (!hasMappedEmployees) {
                this.modalService.alert('MESSAGE_ADP_NO_EMPLOYEES_MAPPED');
                return;
            }

            const hasAlreadyBeenSubmitted: boolean = this.payrollItem.adpRequestStatus === Meevo.Model.PayrollAdpRequestStatusEnum.Sent;
            let messageKey = 'MESSAGE_ADP_ABOUT_TO_SUBMIT';
            if (this.payrollItem.isMultiLocationPayroll)
                messageKey = 'MESSAGE_ADP_ML_ABOUT_TO_SUBMIT';
            if (hasAlreadyBeenSubmitted) {
                messageKey = 'MESSAGE_ADP_ALREADY_SUBMITTED';
            }
            this.modalService.confirm(messageKey).then(shouldContinue => {
                if (shouldContinue) {
                    this.busyService.start();
                    this.payrollService.submitToAdp(this.payrollItem, employeePayId).then(response => {
                        this.busyService.stop();
                        if (response.data.success) {
                            this.modalService.message('MESSAGE_ADP_SUCCESSFULLY_SUBMITTED').then(() => {
                                this.getPayrollItem(this.payrollItem);
                            });
                        } else {
                            const message = response.data.exceptionMessage;
                            this.modalService.error(message).then(() => {
                                this.getPayrollItem(this.payrollItem);
                            });
                        }
                    }).catch(() => {
                        this.busyService.stop();
                    });
                }
            });
        }

        public showAdpLog(payrollPeriod: IPayrollPeriod, event: MouseEvent): void {
            event.stopPropagation();
            this.modalService.showCustom({
                templateUrl: "app/plugins/payroll/views/adpSubmitLog.template.html",
                controller: "meevo.plugins.payroll.AdpSubmitLogController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    payrollPeriod
                }
            }).then(response => {

            });
        }

        launchAdpLoginLink(): void {

            this.securityService.checkModuleAccess(SecurityKeys.INTEGRATION_ADPINTEGRATION + SecurityParts.KEY_PART_READ)
                .then((securityAccess) => {
                    if (securityAccess == Meevo.Model.SecurityAccessEnum.Grant && this.adpIntegration.adpConnectorId && this.adpIntegration.adpIntegrationStatus) {
                            const adpRunLoginLink = window['AdpRunLoginLink'];
                            window.open(adpRunLoginLink, '_blank');
                        }
                    });

            this.securityService.checkModuleAccess(SecurityKeys.INTEGRATION_ADPWFNINTEGRATION + SecurityParts.KEY_PART_READ)
                .then((securityAccess) => {
                    if (securityAccess == Meevo.Model.SecurityAccessEnum.Grant && this.adpIntegration.adpWFNConnectorId && this.adpIntegration.adpWFNIntegrationStatus) {
                        const adpWfnLoginLink = window['AdpWfnLoginLink'];
                        window.open(adpWfnLoginLink, '_blank');
                    }
                });
        }
    }

    angular.module("meevo.plugins.payroll")
        .controller("meevo.plugins.payroll.PayrollController", PayrollController);
}
